__turbopack_context__.v({
  "list": "CurrencyDropdown-module-scss-module__-uE43G__list",
  "listItem": "CurrencyDropdown-module-scss-module__-uE43G__listItem",
});
